import React from "react";
import Header from "../components/Header";
import FooterWithMenu from "../components/Footer"

const CompanyPolicies = () => {
  return (
    <>
      <Header />
      <div
        className="relative py-12 bg-[#FFFCF2]"
        style={{
          backgroundImage: "url('/assets/svg/plain_dot.svg')",
        }}
      >
        <img
          src="/assets/png/gradient.png"
          alt="gradient"
          className="absolute top-0 w-full h-full opacity-80 z-0"
        />
        <div className="relative z-10 w-[95%] md:w-[80%] mx-auto bg-[#ffffffc0] p-6 md:p-12 rounded-xl shadow-md space-y-12">
          <h1 className="text-3xl md:text-4xl font-inter font-semibold text-[#1E1A1C]">
            Company Policies
          </h1>

          {/* Privacy Policy */}
          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-[#1E1A1C]">
              Privacy Policy
            </h2>
            <p className="text-[#363435] font-lexend text-sm md:text-base">
              We are committed to protecting your privacy. This Privacy Policy
              outlines how we collect, use, and protect your personal
              information.
            </p>
            <ul className="list-disc list-inside text-[#363435] font-lexend space-y-2">
              <li>
                <strong>Information We Collect:</strong> Name, email address,
                phone number, project-related information, payment details
                (processed securely via third-party gateways), and website usage
                data via cookies and analytics tools (e.g., Google Analytics).
              </li>
              <li>
                <strong>How We Use Your Information:</strong> To contact you
                regarding inquiries or projects, provide and improve our
                services, process transactions, and send updates or marketing
                (with consent).
              </li>
              <li>
                <strong>Data Sharing:</strong> We do not sell or rent your data.
                We may share it only with trusted third parties for service
                delivery, compliance, or legal obligations.
              </li>
              <li>
                <strong>Security:</strong> We implement standard security
                practices but cannot guarantee 100% security in online
                transmission.
              </li>
              <li>
                <strong>Your Rights:</strong> You can request to access, update,
                or delete your personal information by contacting us at
                info@hanatoria.com.
              </li>
            </ul>
          </section>

          {/* Terms & Conditions */}
          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-[#1E1A1C]">
              Terms & Conditions
            </h2>
            <ul className="list-disc list-inside text-[#363435] font-lexend space-y-2">
              <li>
                <strong>Services:</strong> We offer Graphic Design, Digital
                Marketing, Web Design & Development, and Video Editing. Scope,
                deliverables, and timelines are project-based.
              </li>
              <li>
                <strong>Payments:</strong> All prices are in INR. 50% advance is
                required. Final files are shared post full payment.
              </li>
              <li>
                <strong>Revisions:</strong> One revision per deliverable is
                included. Additional revisions are chargeable.
              </li>
              <li>
                <strong>Intellectual Property:</strong> Final files are
                transferred after full payment. We may showcase the work in our
                portfolio.
              </li>
              <li>
                <strong>Cancellations & Refunds:</strong> See Refund Policy.
              </li>
              <li>
                <strong>Liability:</strong> We are not responsible for
                business/reputation/third-party losses due to our services.
              </li>
              <li>
                <strong>Jurisdiction:</strong> All disputes are under
                Coimbatore, Tamil Nadu, India jurisdiction.
              </li>
            </ul>
          </section>

          {/* Intellectual Property Rights */}
          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-[#1E1A1C]">
              Intellectual Property Rights
            </h2>
            <ul className="list-disc list-inside text-[#363435] font-lexend space-y-2">
              <li>
                <strong>Ownership:</strong> Final deliverables become client
                property after payment. Drafts, mockups, source files remain
                with Hanatoria unless agreed otherwise.
              </li>
              <li>
                <strong>Usage Restrictions:</strong> No reuse, resell, or
                redistribution without written permission. Portfolio use must
                credit Hanatoria.
              </li>
              <li>
                <strong>Brand & Attribution:</strong> Missing credit or
                plagiarism is a breach. Legal action may be taken.
              </li>
              <li>
                <strong>Portfolio Use:</strong> We may showcase non-confidential
                work in our portfolio or marketing materials.
              </li>
            </ul>
          </section>

          {/* Refund & Cancellation Policy */}
          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-[#1E1A1C]">
              Refund & Cancellation Policy
            </h2>
            <ul className="list-disc list-inside text-[#363435] font-lexend space-y-2">
              <li>
                <strong>Cancellations:</strong> Full refund if cancelled before
                work starts. No refund once work begins.
              </li>
              <li>
                <strong>Refund Conditions:</strong> No refunds after service
                completion. For ongoing services, refund is only possible before
                the monthly cycle starts.
              </li>
              <li>
                <strong>Refund Process:</strong> Refunds (if approved) are
                processed within 7 working days via original payment method.
              </li>
              <li>
                <strong>Exceptions:</strong> No refund for change of mind after
                delivery, delays due to client-side issues, or unused revisions.
              </li>
            </ul>
          </section>
        </div>
      </div>
      <FooterWithMenu />
    </>
  );
};

export default CompanyPolicies;
